import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  alert: {
    color: theme.palette.error.main,
    paddingTop: "10px",
    paddingBottom: "10px"
  }
}));

export default function UnsavedChangeAlert(): JSX.Element {
  const classes = useStyles();
  return (
    <tr className="alertRow">
      <td colSpan={3} className={classes.alert}>
        Save or cancel before continuing
      </td>
    </tr>
  );
}
